import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

export type DeleteHazardDialogProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isDeleting: boolean
  copy?: 'delete' | 'remove'
}

export function DeleteHazardDialog({
  isOpen,
  onClose,
  onConfirm,
  isDeleting,
  copy = 'delete',
}: DeleteHazardDialogProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')
  const isRemove = copy === 'remove'
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className='sm:max-w-md' showCloseButton={!isDeleting}>
        <DialogHeader>
          <DialogTitle>
            {isRemove
              ? t('hazardsPage.removeUncertainDialog.title')
              : t('hazardsPage.deleteDialog.title')}
          </DialogTitle>
        </DialogHeader>
        <p className='text-sm text-muted-foreground'>
          {isRemove
            ? t('hazardsPage.removeUncertainDialog.message')
            : t('hazardsPage.deleteDialog.message')}
        </p>
        <DialogFooter>
          <Button variant='outline' onClick={onClose} disabled={isDeleting}>
            {t('common:actions.cancel')}
          </Button>
          <Button variant='destructive' onClick={onConfirm} disabled={isDeleting}>
            {isDeleting
              ? isRemove
                ? t('hazardsPage.removeUncertainDialog.removing')
                : t('hazardsPage.deleteDialog.deleting')
              : isRemove
                ? t('hazardsPage.removeUncertainDialog.remove')
                : t('hazardsPage.deleteDialog.delete')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
